import { NSTable } from 'bricks';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import { BedMix, TotalGrossRent } from 'views/ProFormaTable/types';
import './InvestmentMemoBedMixTable.scss';

export interface InvestmentMemoBedMixTableProps {
    bedMix: BedMix[];
    totals: TotalGrossRent;
}

const InvestmentMemoBedMixTable = ({ bedMix, totals }: InvestmentMemoBedMixTableProps) => (
    <div className="InvestmentMemoBedMixTable">
        <div className="text-primary ml-2 mt-2 pb-0">BED MIX</div>
        <NSTable className="NSTable mb-0 mx-0 px-0">
            <thead className="NSTable__thead">
                <tr className="NSTable__thead__tr">
                    <th className="NSTable__thead__tr__th pb-1 text-left text-dark">Units</th>
                    <th className="NSTable__thead__tr__th pb-1 text-right text-dark">Total beds</th>
                    <th className="NSTable__thead__tr__th pb-1 text-right text-dark">Avg SF</th>
                    <th className="NSTable__thead__tr__th pb-1 text-right text-dark">Rent/bed/mo</th>
                    <th className="NSTable__thead__tr__th pb-1 text-right text-dark">Pro forma rent</th>
                </tr>
            </thead>
            <tbody className="NSTable__tbody">
                {bedMix.map(row => (
                    <tr key={`bed-mix-${row.id}`} className="NSTable__tbody__tr">
                        <td className="NSTable__tbody__tr__td py-1 text-left text-dark">
                            {row.units?.toLocaleString() ?? '-'}
                        </td>
                        <td className="NSTable__tbody__tr__td py-1 text-right text-dark">
                            {row.totalBeds?.toLocaleString() ?? '-'}
                        </td>
                        <td className="NSTable__tbody__tr__td py-1 text-right text-dark">
                            {row.averageSf?.toLocaleString() ?? '-'}
                        </td>
                        <td className="NSTable__tbody__tr__td py-1 text-right text-dark">
                            {row.amountOfRentPerBed != null
                                ? numeralFormatterCurrency(row.amountOfRentPerBed, '$0,0')
                                : '-'}
                        </td>
                        <td className="NSTable__tbody__tr__td py-1 text-right text-dark">
                            {row.amountPerYear != null
                                ? numeralFormatterCurrency(row.amountPerYear, '$0,0')
                                : '-'}
                        </td>
                    </tr>
                ))}
                <tr className="NSTable__tbody__tr">
                    <td className="NSTable__tbody__tr__td pt-1 text-left text-dark">
                        {totals?.totalUnits?.toLocaleString() ?? '-'}
                    </td>
                    <td className="NSTable__tbody__tr__td pt-1 text-right text-dark">
                        {totals?.totalBeds?.toLocaleString() ?? '-'}
                    </td>
                    <td className="NSTable__tbody__tr__td pt-1 text-right text-dark">
                        {totals?.averageSf?.toLocaleString() ?? '-'}
                    </td>
                    <td className="NSTable__tbody__tr__td pt-1 text-right text-dark">
                        {totals?.pricePerBed != null
                            ? numeralFormatterCurrency(totals.pricePerBed, '$0,0')
                            : '-'}
                    </td>
                    <td className="NSTable__tbody__tr__td pt-1 text-right text-dark">
                        {totals?.totalAmountPerYear != null
                            ? numeralFormatterCurrency(totals.totalAmountPerYear, '$0,0')
                            : '-'}
                    </td>
                </tr>
            </tbody>
        </NSTable>
    </div>
);

export default InvestmentMemoBedMixTable;
